import styled from 'styled-components';

export const ConnectMenusaStyled = styled.div``;

export const UnitsListStyled = styled.div``;
export const UnitsListItemStyled = styled.div``;

export const UnitNameStyled = styled.p``;

export const UnitButtonStyled = styled.button``;

export const ModalTitleStyled = styled.h3`
	margin-bottom: 24px;
	font-size: 24px;
`;
